import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FlorderSelectCustomerComponent } from 'app/modules/florder/florder-select-customer/florder-select-customer.component';
import { FlorderRecurrenceComponent } from 'app/modules/florder/recurrence/florder-recurrence.component';
import { CoreModule } from 'app/core/core.module';

import { AngularMaterialModule, SharedModule } from 'app/shared';
import { CCRRoutingModule } from 'app/modules/ccr/ccr-routing.module';
import { FlowsRoutingModule } from 'app/modules/flows/flows-routing.module';
import { OrdersRoutingModule } from 'app/modules/orders/orders-routing.module';

@NgModule({
  imports: [CommonModule, OrdersRoutingModule, FlowsRoutingModule, CCRRoutingModule, AngularMaterialModule, SharedModule, CoreModule, ReactiveFormsModule],
  exports: [FlorderRecurrenceComponent, FlorderSelectCustomerComponent],
  declarations: [FlorderRecurrenceComponent, FlorderSelectCustomerComponent],
})
export class FlorderModule {}
